import React, { createContext, useContext } from 'react';
import type { TicketsType } from './types';

export const TicketsContext = createContext<TicketsType | null>(null);

export const useTicketsContext = () => {
    const value = useContext(TicketsContext);

    if (!value) {
        throw new Error('useTicketsContext must be used within TicketContext');
    }

    return value;
};

export const TicketsProvider: React.FC<{
    value: TicketsType;
}> = ({ children, value }) => {
    return (
        <TicketsContext.Provider value={value}>
            {children}
        </TicketsContext.Provider>
    );
};
